export default __webpack_public_path__ + "static/media/19.889b2bc5.jpg";